import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import { useForm, SubmitHandler } from "react-hook-form";
import { useMutation } from "react-query";
import { useDispatch } from "react-redux";
import { useHistory, useRouteMatch } from "react-router-dom";

import { Button } from "components";
import { pendService } from "services";
import { uiActions } from "store";
import { NameId, PendFrom } from "types";

import DetailsField from "../components/detailsField";
import PendedToSelect from "../components/pendedToSelect";
import ReasonSelect from "../components/reasonSelect";

type AddPendFormProps = {
	id: string;
	nameId: NameId;
	pendFrom: PendFrom;
};

type FormData = {
	details: any;
	reasons: any;
	pendedTo: any;
};

const AddPendForm = ({ id, nameId, pendFrom }: AddPendFormProps) => {
	const { url, params } = useRouteMatch<any>();
	const history = useHistory();
	const dispatch = useDispatch();

	const { mutateAsync: addPend, isLoading } = useMutation(
		pendService.addPend,
	);

	const { register, handleSubmit, control, formState, setValue } =
		useForm<FormData>({
			mode: "onChange",
			defaultValues: {},
		});

	const { errors } = formState;

	const { isDirty, isSubmitting } = formState;

	const redirectToEditPage = id => {
		const currentPageUrl = url;
		const editPageUrl =
			currentPageUrl.substring(0, currentPageUrl.lastIndexOf("/")) +
			`/${id}`;
		const currentQueue = editPageUrl.split("/")?.[1];

		if (
			params?.tab === "in-review" ||
			params?.tab === "in-progress" ||
			params?.tab === "unassigned"
		) {
			history.push(`/${currentQueue}/pended/${params?.id}/pend/${id}`);
		} else {
			history.push(editPageUrl);
		}
	};

	const handleSubmitForm: SubmitHandler<FormData> = ({
		details,
		reasons,
		pendedTo,
	}) => {
		const reasonIds = reasons.map(({ id }) => id);

		addPend({
			name: nameId,
			id,
			details,
			reasonIds,
			pendedToId: pendedTo?.id,
			pendFrom,
		}).then(
			id => {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Pend has been successfully added.",
					}),
				);
				redirectToEditPage(id);
			},
			error => {
				dispatch(
					uiActions.showErrorNotification({
						title: error?.Message,
					}),
				);
			},
		);
	};

	return (
		<Form onSubmit={handleSubmit(handleSubmitForm)}>
			<Row>
				<Col xs="6" md="4" lg="3" className="mr-5">
					<Form.Group className="mb-4">
						<PendedToSelect
							errors={errors}
							control={control}
							loading={isLoading}
						/>
					</Form.Group>
					<Form.Group className="mb-4">
						<ReasonSelect
							errors={errors}
							control={control}
							loading={isLoading}
							setValue={setValue}
						/>
					</Form.Group>
				</Col>
				<Col>
					<Form.Group className="mb-4">
						<DetailsField
							errors={errors}
							register={register}
							loading={isLoading}
						/>
					</Form.Group>
				</Col>
			</Row>
			<Row>
				<Col>
					<Button
						value="Save"
						disabled={!isDirty || isSubmitting || isLoading}
						type="submit"
					/>
				</Col>
			</Row>
		</Form>
	);
};

export default AddPendForm;
